export const minAmount = {
  EUR: '500.00',
  GBP: '500.00',
  ZAR: '5000.00',
  USD: '500.00',
  NGN: '1000.00',
}
